export default {
  name: "BolideLoader",
  mounted() {
    this.initInfinityLoader();
  },
  methods: {
    initInfinityLoader() {
      const svg = document.querySelector(".infinity-loader");
      if (!svg) return;
      svg.style.opacity = "1";
    }
  }
};
